exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.InputSelect .LabelPart .error_message {\n    position: absolute;\n}\n", ""]);

// exports
